/**
 * Touch 'n Go icon URL
 * Malaysia's popular e-wallet payment method
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const TNG_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/15FHwC4H3W0JrNvsqy6TWH/5d18aa44231c55d6457389e17ac7ea0c/TnG.svg';
